import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatType } from './types';
import { getGreetingMessage, sendMessage } from './chatbot.action';

export type IInitialState = {
  chats: ChatType[];
  isAgentSpeaking?: boolean;
  audioVisualizerOpen?: boolean;
};

const initialState: IInitialState = {
  chats: [],
  isAgentSpeaking: false,
  audioVisualizerOpen: false,
};

const ChatbotSlice = createSlice({
  name: 'chatbot',
  initialState,
  reducers: {
    setInititalChat: (state, action: PayloadAction<ChatType>) => {
      state.chats = [action.payload];
    },
    setChats: (state, action: PayloadAction<ChatType>) => {
      state.chats.push(action.payload);
    },

    setIsAgentSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isAgentSpeaking = action.payload;
    },
    toggleAudioVisualizer: (state) => {
      state.audioVisualizerOpen = !state.audioVisualizerOpen;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendMessage.fulfilled, (state, action) => {
      const lastIndex = state.chats.length - 1;
      if (lastIndex >= 0) {
        state.chats[lastIndex] = action.payload;
      }
    });
    builder.addCase(sendMessage.rejected, (state) => {
      const lastIndex = state.chats.length - 1;
      if (lastIndex >= 0) {
        state.chats[lastIndex] = {
          error: '😔 I’am sorry! Something went wrong! Please try again...',
          message: '',
          sender: 'bot',
          loading: false,
        };
      }
    });

    // getGreetingMessage
    builder.addCase(getGreetingMessage.pending, (state) => {
      state.chats = [
        {
          message: 'Loading...',
          sender: 'bot',
          loading: true,
        },
      ];
    });
    builder.addCase(getGreetingMessage.fulfilled, (state, action) => {
      state.chats = [action.payload];
    });
  },
});
export const { setChats, setInititalChat, setIsAgentSpeaking, toggleAudioVisualizer } =
  ChatbotSlice.actions;
export default ChatbotSlice.reducer;
